import { formatMoneyV2, formatNumberWithDots, formatPercent } from '~/helpers'

type Formatters = {
  [key in MetricsFormats]: (data: string | number | null) => string
}

const formatters: Formatters = {
  unit: value => formatNumberWithDots(value),
  money: value => formatMoneyV2({ value }),
  percent: value => formatPercent(value)
}

type FormatNumberByTypeProps = {
  type: MetricsFormats
  value: string | number | null
}

/** `null` quando o valor está ausente ou não é numérico; nunca vira 0. */
export const toNullableNumber = (value: unknown): number | null => {
  if (value == null) return null

  if (typeof value === 'string') {
    const trimmed = value.trim()

    if (!trimmed) return null

    const parsed = Number(trimmed)

    return Number.isFinite(parsed) ? parsed : null
  }

  const parsed = Number(value)

  return Number.isFinite(parsed) ? parsed : null
}

export const formatNumberByType = ({
  type,
  value
}: FormatNumberByTypeProps) => {
  return formatters[type](value)
}
